import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../../components/Footer';
export function TermsOfUsePage() {
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-4414">
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-4415">
        <Link to="/" className="flex items-center gap-2" data-id="element-4416">
          <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-4417"></div>
          <span className="font-bold text-xl tracking-tight" data-id="element-4418">
            Citiplots.com
          </span>
        </Link>
      </header>

      <main className="flex-1 max-w-4xl mx-auto px-6 py-12" data-id="element-4419">
        <h1 className="text-4xl font-bold mb-4" data-id="element-4420">Terms of Use</h1>
        <p className="text-sm text-gray-500 mb-8 font-mono" data-id="element-4421">
          Last Updated: {new Date().toLocaleDateString()}
        </p>

        <div className="bg-white border border-gray-300 p-8 space-y-8" data-id="element-4422">
          <section data-id="element-4423">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4424">1. Acceptance of Terms</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4425">
              By accessing and using Citiplots.com ("Platform"), you accept and
              agree to be bound by these Terms of Use. If you do not agree to
              these terms, please do not use our services.
            </p>
            <p className="text-gray-700 leading-relaxed" data-id="element-4426">
              These terms constitute a legally binding agreement between you and
              Citiplots Private Limited ("Company", "we", "us", or "our"), a
              company incorporated under the laws of India.
            </p>
          </section>

          <section data-id="element-4427">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4428">2. Platform Services</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4429">
              Citiplots.com provides an online marketplace platform that
              facilitates direct transactions between property sellers and
              buyers for plot and land purchases in India. Our services include:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-4430">
              <li data-id="element-4431">Property listing and discovery services</li>
              <li data-id="element-4432">Document verification and legal compliance tools</li>
              <li data-id="element-4433">Communication and inquiry management</li>
              <li data-id="element-4434">Transaction facilitation and escrow services</li>
              <li data-id="element-4435">
                NRI-specific services including POA management and tax
                calculators
              </li>
            </ul>
          </section>

          <section data-id="element-4436">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4437">3. User Eligibility</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4438">
              To use this Platform, you must:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-4439">
              <li data-id="element-4440">Be at least 18 years of age</li>
              <li data-id="element-4441">Have the legal capacity to enter into binding contracts</li>
              <li data-id="element-4442">Provide accurate and complete registration information</li>
              <li data-id="element-4443">Maintain the security of your account credentials</li>
              <li data-id="element-4444">Comply with all applicable laws and regulations</li>
            </ul>
          </section>

          <section data-id="element-4445">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4446">4. User Obligations</h2>
            <h3 className="text-lg font-bold mb-2" data-id="element-4447">4.1 Sellers</h3>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4448">
              As a seller, you represent and warrant that:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4 mb-4" data-id="element-4449">
              <li data-id="element-4450">
                You have clear and marketable title to the property listed
              </li>
              <li data-id="element-4451">
                All information provided is accurate, complete, and not
                misleading
              </li>
              <li data-id="element-4452">All documents uploaded are genuine and legally valid</li>
              <li data-id="element-4453">The property is free from encumbrances unless disclosed</li>
              <li data-id="element-4454">
                You will respond to inquiries in a timely and professional
                manner
              </li>
            </ul>

            <h3 className="text-lg font-bold mb-2" data-id="element-4455">4.2 Buyers</h3>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4456">
              As a buyer, you agree to:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-4457">
              <li data-id="element-4458">Conduct due diligence before making any purchase</li>
              <li data-id="element-4459">Verify all property documents independently</li>
              <li data-id="element-4460">Engage qualified legal counsel for transaction review</li>
              <li data-id="element-4461">Make payments only through Platform-approved methods</li>
              <li data-id="element-4462">Comply with all FEMA regulations (for NRI buyers)</li>
            </ul>
          </section>

          <section data-id="element-4463">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4464">
              5. Prohibited Activities
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4465">You may not:</p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-4466">
              <li data-id="element-4467">Post false, misleading, or fraudulent listings</li>
              <li data-id="element-4468">Engage in price manipulation or bid rigging</li>
              <li data-id="element-4469">Circumvent Platform fees or payment systems</li>
              <li data-id="element-4470">Harass, threaten, or abuse other users</li>
              <li data-id="element-4471">Scrape, copy, or misuse Platform content</li>
              <li data-id="element-4472">Upload malicious code or attempt to breach security</li>
              <li data-id="element-4473">Impersonate any person or entity</li>
              <li data-id="element-4474">Violate any applicable laws or regulations</li>
            </ul>
          </section>

          <section data-id="element-4475">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4476">6. Platform Fees</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4477">
              The Platform charges fees for certain services as disclosed at the
              time of transaction. Fees are non-refundable except as required by
              law. We reserve the right to modify fees with 30 days' notice.
            </p>
          </section>

          <section data-id="element-4478">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4479">
              7. Limitation of Liability
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4480">
              Citiplots.com is a marketplace platform and not a party to
              transactions between users. We:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-4481">
              <li data-id="element-4482">
                Do not guarantee the accuracy of listings or user-provided
                information
              </li>
              <li data-id="element-4483">
                Are not responsible for the quality, legality, or condition of
                properties
              </li>
              <li data-id="element-4484">Do not provide legal, tax, or financial advice</li>
              <li data-id="element-4485">Are not liable for disputes between users</li>
              <li data-id="element-4486">
                Limit our liability to the maximum extent permitted by law
              </li>
            </ul>
          </section>

          <section data-id="element-4487">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4488">8. Indemnification</h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-4489">
              You agree to indemnify and hold harmless Citiplots.com, its
              affiliates, officers, directors, employees, and agents from any
              claims, damages, losses, liabilities, and expenses arising from
              your use of the Platform or violation of these Terms.
            </p>
          </section>

          <section data-id="element-4490">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4491">9. Dispute Resolution</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4492">
              Any disputes arising from these Terms shall be resolved through:
            </p>
            <ol className="list-decimal list-inside space-y-2 text-gray-700 ml-4" data-id="element-4493">
              <li data-id="element-4494">Good faith negotiations between parties</li>
              <li data-id="element-4495">
                Mediation in accordance with Indian Arbitration and Conciliation
                Act, 1996
              </li>
              <li data-id="element-4496">Arbitration in Mumbai, Maharashtra, India</li>
            </ol>
            <p className="text-gray-700 leading-relaxed mt-4" data-id="element-4497">
              These Terms shall be governed by the laws of India, and courts in
              Mumbai shall have exclusive jurisdiction.
            </p>
          </section>

          <section data-id="element-4498">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4499">10. Modifications</h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-4500">
              We reserve the right to modify these Terms at any time. Material
              changes will be notified via email or Platform notification.
              Continued use after changes constitutes acceptance of modified
              Terms.
            </p>
          </section>

          <section data-id="element-4501">
            <h2 className="text-2xl font-bold mb-4" data-id="element-4502">11. Contact Information</h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-4503">
              For questions about these Terms, please contact us at:
            </p>
            <div className="mt-4 p-4 bg-gray-50 border border-gray-200" data-id="element-4504">
              <p className="font-mono text-sm" data-id="element-4505">
                Citiplots Private Limited
                <br data-id="element-4506" />
                Email: legal@citiplots.com
                <br data-id="element-4507" />
                Address: [Company Registered Address]
                <br data-id="element-4508" />
                Phone: +91-XXX-XXX-XXXX
              </p>
            </div>
          </section>
        </div>
      </main>

      <Footer data-id="element-4509" />
    </div>;
}